import React from 'react';
import Button from 'react-bootstrap/Button';
import POSTER from '../assets/main_image2.png';
import kakaobtn from '../assets/kakao.png';
import styled from 'styled-components';
import profile_img from '../assets/main_image.png';

const { Kakao } = window;

const KakaoShareBtn = ({ data }) => {
	const url = "https://previouslife.click/";
	let ShareURL, ShareDesc, ShareImg, ShareTitle;

	if (data.pageID == 'startPage') {
		ShareURL = url;
		ShareDesc = "나는 전생에 어떤 사람?";
		ShareImg = 'https://previouslife.click' + profile_img;
		ShareTitle = '전생 알아보러 가기';

	} else {
		ShareURL = url + 'result/' + data.UUID;
		ShareDesc = data.data;
		ShareImg = 'https://previouslife.click' + profile_img;
		ShareTitle = '친구 결과보고 테스트 해보기';
	}

	React.useEffect(() => {
		Kakao.cleanup();
		Kakao.init("fe7f698a2736e423d4cd3648e7dfd897");
	}, []);

	const shareKakao = () => {
		Kakao.Share.sendDefault({
			// window.Kakao.Link.sendDefault({
			objectType: 'feed',
			content: {
				title: 'ChatGPT가 알려주는 전생 이야기',
				imageUrl: encodeURI(ShareImg),
				link: {
					mobileWebUrl: ShareURL,
					webUrl: ShareURL,
				},
				description: ShareDesc,
			},
			social: {
				likeCount: 9876,
				sharedCount: 51088,
				viewCount: 102072,
			},
			buttons: [
				{
					title: ShareTitle,
					link: {
						mobileWebUrl: ShareURL,
						webUrl: ShareURL,
					},
				},
			]
		});
	}

	return (
		<KakaoSharedButt onClick={shareKakao}>
			<KakaoIcon src={kakaobtn}></KakaoIcon>
		</KakaoSharedButt>
	);
}

export default KakaoShareBtn;

const KakaoSharedButt = styled.a`
cursor:pointer;
`;

const KakaoIcon = styled.img`
width:50px;
height:50px;
border-radius:24px
`;